import React, { useState, useEffect } from 'react'
import Nav from 'react-bootstrap/Nav';
import Row from 'react-bootstrap/Row';
import Tab from 'react-bootstrap/Tab';
import Col from 'react-bootstrap/Col';
import { Viewer, Worker } from "@react-pdf-viewer/core"
import { toolbarPlugin } from "@react-pdf-viewer/toolbar"
import "@react-pdf-viewer/core/lib/styles/index.css"
import "@react-pdf-viewer/toolbar/lib/styles/index.css"
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import PropagateLoader from "react-spinners/PropagateLoader";
import { startQuizRes, startQuizTodo } from '../../LMS_Redux/LMS_Slices/Course/StartQuiz';
import { ToastContainer, toast } from 'react-toastify';
import { getCourseTimerRes, getCourseTimerTodo } from '../../LMS_Redux/LMS_Slices/Course/GetCourseTimer';
import { saveCourseTimerTodo } from '../../LMS_Redux/LMS_Slices/Course/SaveCourseTimer';
import { Formik, Form } from 'formik';
import { AddNotesSchema, AddQuestionSchema } from './CourseManagementSchema';
import { addNoteRes, addNoteTodo } from '../../LMS_Redux/LMS_Slices/Course/AddNotes';
import { notesListTodo } from '../../LMS_Redux/LMS_Slices/Course/NotesList';
import DataTables from '../LMS_DATA_TABLE/DataTable';
import { FaTimes } from 'react-icons/fa';
import { Tooltip } from 'react-tooltip';
import Swal from 'sweetalert2';
import { delNoteRes, delNoteTodo } from '../../LMS_Redux/LMS_Slices/Course/DeleteNote';
import { addUpdateLearnerQuestionRes, addUpdateLearnerQuestionTodo } from '../../LMS_Redux/LMS_Slices/Course/AddUpdateLearnerQuestion';
import { learnerCourseDetailsRes, learnerCourseDetailsTodo } from '../../LMS_Redux/LMS_Slices/Course/LearnerCourseDetails';
import ResultMeter from './ResultMeter';
import { FaDownload } from 'react-icons/fa6';
import { Rating } from 'react-simple-star-rating';
import { quizResultRes, quizResultTodo } from '../../LMS_Redux/LMS_Slices/Course/QuizResult';
import { IoIosCheckmarkCircle } from "react-icons/io";
import { getCertificateRes, getCertificateTodo } from '../../LMS_Redux/LMS_Slices/Course/GetCertificate';
import { Spinner } from 'react-bootstrap';


export default function LearnerCourseDetails(props) {

    const { state } = useLocation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const details = useSelector(state => state.learnerCourseDetails && state.learnerCourseDetails.data && state.learnerCourseDetails.data.data && state.learnerCourseDetails.data.data[0])
    // const time = useSelector(state => state.getCourseTimer && state.getCourseTimer.data && state.getCourseTimer.data.data)
    const notes = useSelector(state => state.notesList && state.notesList.data && state.notesList.data.data)
    const [loading, setLoading] = useState(false)
    const [questionLoading, setQuestionLoading] = useState(true)
    const [notesBool, setNotesBool] = useState(false)
    const [spinner, setSpinner] = useState(false)
    const [bool, setBool] = useState(false)
    const [time, setTime] = useState();
    const [isRunning, setIsRunning] = useState(false)
    const [triggered, setTriggered] = useState(false)
    const result = useSelector(state => state.quizResult && state.quizResult.data && state.quizResult.data.data)

    // const userRole = JSON.parse(localStorage.getItem('user_data'));
    // const role = userRole && userRole.vrole_name

    const toolbarPluginInstance = toolbarPlugin()
    const { Toolbar } = toolbarPluginInstance

    const [columnDefs, setColumnDefs] = useState([
        {
            headerName: 'NOTES',
            field: 'note',
            filter: 'agTextColumnFilter',
            suppressMenu: true,
            filter: true,
            sortable: true,
            floatingFilter: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            headerName: 'CREATED ON',
            field: 'createdAt',
            filter: 'agDateColumnFilter',
            filterParams: {
                comparator: (dateFromFilter, cellValue) => {
                    // console.log("date", dateFromFilter)
                    // console.log("cell", cellValue)

                    if (cellValue == null) { return 0 };

                    const dateParts = cellValue.split('/');
                    // console.log(dateParts)
                    const day = Number(dateParts[0]);
                    const month = Number(dateParts[1]) - 1;
                    const year = Number(dateParts[2]);

                    const cellDate = new Date(year, month, day);

                    if (cellDate < dateFromFilter) {
                        return -1;
                    } else if (cellDate > dateFromFilter) {
                        return 1;
                    }
                    return 0
                },
                // minValidYear: 2000,
                // maxValidYear: 2021,
                inRangeFloatingFilterDateFormat: 'Do MMM YYYY',
            },
            suppressMenu: true,
            sortable: true,
            floatingFilter: true,
            suppressFiltersToolPanel: true,
            // wrapText: true,
            // autoHeight: true,
        },
        {
            field: 'ACTIONS',
            cellRenderer: params =>
                <div>
                    <FaTimes size={20} className='delete ms-3'
                        onClick={() => del_note(params)}
                        data-tooltip-id='cancel'
                        data-tooltip-content="Delete Note!"
                        data-tooltip-place="bottom"
                    />

                    <Tooltip id='cancel' style={{ backgroundColor: "rgb(239, 61, 80)", zIndex: '9', lineHeight: 'normal' }} />
                </div>,
            autoHeight: true,
        }
    ])

    const del_note = (params) => {
        // console.log(params.data)
        Swal.fire({
            title: 'Delete Note',
            text: `Are you sure want to Delete Note?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#105684',
            cancelButtonColor: '#9d9d9d',
            confirmButtonText: 'Ok'
        }).then((result) => {
            if (result.isConfirmed) {
                // console.log(params.data.id)
                dispatch(delNoteTodo(params.data.id)).then(() => del_note_res())
            }
        })
    }

    const del_note_res = () => {
        // console.log(cancelTrainingRes)
        if (delNoteRes && delNoteRes.success) {
            Swal.fire(
                'Notes Status',
                delNoteRes.message,
                'success'
            )
            dispatch(notesListTodo({ "course_id": state.course_id }))
        } else {
            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: delNoteRes.message,
            })
        }
    }

    const start_quiz = () => {
        dispatch(startQuizTodo({
            "course_id": details && details.lms_course_quiz.course_id,
            "quiz_id": details && details.lms_course_quiz.quiz_id,
            "max_attempt_count": details && details.lms_course_quiz && details.lms_course_quiz.max_attemps_count,
            "passing_marks": details && details.lms_course_quiz && details.lms_course_quiz.passing_marks,
            "total_marks": details && details.lms_course_quiz && details.lms_course_quiz.total_marks,
            "training_id": state && state.fk_training_id
        })).then(() => start_quiz_res())
    }

    const start_quiz_res = () => {
        if (startQuizRes && startQuizRes.success) {
            var order = state && state.course_order
            navigate('/course_quiz', { state: { ...details.lms_course_quiz, order } })
        } else {
            toast.error(startQuizRes.message, { position: "bottom-right" })
        }
    }

    const details_res = () => {
        if (learnerCourseDetailsRes && learnerCourseDetailsRes.success) {
            // var id = learnerCourseDetailsRes && learnerCourseDetailsRes.data && learnerCourseDetailsRes.data[0] && learnerCourseDetailsRes.data[0].lms_learner_quizzes && learnerCourseDetailsRes.data[0].lms_learner_quizzes[0] && learnerCourseDetailsRes.data[0].lms_learner_quizzes[0].id
            const id = learnerCourseDetailsRes?.data?.[0]?.lms_learner_quizzes?.slice(-1)?.[0]?.id || null;

            dispatch(quizResultTodo(id)).then(() => quiz_result_res())
            {
                state && state.learner_course_status == 'pass' || state && state.learner_course_status == 'expired' ?
                    setLoading(false)
                    :
                    dispatch(getCourseTimerTodo(state.course_id)).then(() => {
                        if (getCourseTimerRes && getCourseTimerRes.success) {
                            var SS = parseInt(getCourseTimerRes.data.ss)

                            setTime(SS)
                            setIsRunning(true)
                            setLoading(false)
                        } else {
                            setLoading(false)
                        }
                    })
            }
        } else {
            setLoading(false)
        }
    }

    const quiz_result_res = () => {
        if (quizResultRes && quizResultRes.success) {
            setQuestionLoading(false)
        } else {
            setQuestionLoading(false)
        }
    }

    useEffect(() => {

        props.setSidebar(false)
        setLoading(true)
        setQuestionLoading(true)
        dispatch(learnerCourseDetailsTodo({ "course_id": state && state.course_id, "training_id": state && state.fk_training_id })).then(() => details_res())
    }, [bool])

    useEffect(() => {
        let interval;

        if (isRunning) {
            interval = setInterval(() => {
                setTime(prevTime => prevTime + 1);
            }, 1000);
        }

        if (isRunning) {
            interval = setInterval(() => {
                dispatch(saveCourseTimerTodo({ "course_id": state.course_id, "time": localStorage.getItem('current_seconds'), "training_id": state.fk_training_id }))
            }, 10000);
        }

        return () => {
            clearInterval(interval);
        }
    }, [isRunning])

    const formatTime = seconds => {

        localStorage.setItem('current_seconds', seconds)
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const remainingSeconds = seconds % 60;

        const formatNumber = num => (num < 10 ? `0${num}` : num);

        return `${formatNumber(hours)}:${formatNumber(minutes)}:${formatNumber(remainingSeconds)}`;
    }

    useEffect(() => {
        dispatch(notesListTodo({ "course_id": state && state.course_id }))
    }, [notesBool])

    const add_note_res = (action) => {
        if (addNoteRes && addNoteRes.success) {
            setNotesBool(!notesBool)
            action.resetForm()
            toast.success(addNoteRes.message, { position: "bottom-right" })
        } else {
            toast.error(addNoteRes.message, { position: "bottom-right" })
        }
    }

    const add_question_res = (action) => {
        if (addUpdateLearnerQuestionRes && addUpdateLearnerQuestionRes.success) {
            action.resetForm()
            toast.success(addUpdateLearnerQuestionRes.message, { position: "bottom-right" })
        } else {
            toast.error(addUpdateLearnerQuestionRes.message, { position: "bottom-right" })
        }
    }

    const mergedArray = result && result.questionList && result.questionList.map((item) => {
        const ans_by_user = result && result.lms_learner_questions && result.lms_learner_questions.find((obj) => obj.question_id === item.question_id)
        return { ...item, ans_by_user }
    })

    useEffect(() => {
        if (!triggered && (parseInt(details?.min_view_time) * 60) < time) {
            if (details?.quiz_attempt_status && state?.learner_course_status !== 'pass') {
                Swal.fire({
                    title: 'Start Quiz',
                    text: `Your Course Reading Time is Completed. Do You want to Start the Quiz?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#105684',
                    cancelButtonColor: '#9d9d9d',
                    confirmButtonText: 'Start Quiz',
                    cancelButtonText: 'Not Right Now',
                }).then((result) => {
                    if (result.isConfirmed) {
                        // console.log(params.data.id)
                        dispatch(startQuizTodo({
                            "course_id": details && details.lms_course_quiz.course_id,
                            "quiz_id": details && details.lms_course_quiz.quiz_id,
                            "max_attempt_count": details && details.lms_course_quiz && details.lms_course_quiz.max_attemps_count,
                            "passing_marks": details && details.lms_course_quiz && details.lms_course_quiz.passing_marks,
                            "total_marks": details && details.lms_course_quiz && details.lms_course_quiz.total_marks,
                            "training_id": state && state.fk_training_id
                        })).then(() => start_quiz_res())
                    }
                })
                setTriggered(true)
            }
        }
    }, [time])


    //---------------------- GENRATE PDF-------------------

    const genratePdf = () => {
        // console.log(result)
        setSpinner(true)
        // dispatch(getCertificateTodo(details?.lms_learner_quizzes?.[0])).then(() => certificate_res())
        dispatch(getCertificateTodo(details?.lms_learner_quizzes?.[details.lms_learner_quizzes.length - 1])).then(() => certificate_res())
    }

    const certificate_res = () => {
        if (getCertificateRes && getCertificateRes.success) {
            setSpinner(false)

            window.open(process.env.REACT_APP_IMAGE_URL + getCertificateRes?.data, '_target_blank')
            toast.success(getCertificateRes.message, { position: "bottom-right" })
            setBool(!bool)
        } else {
            setSpinner(false)
            toast.error(getCertificateRes.message, { position: "bottom-right" })
        }
    }

    return (
        <>
            <div className='container-fluid'>
                <div className='scnd-header align-items-center' style={{ justifyContent: 'space-between' }}>
                    <div>
                        <span className='icon1'>Learning Module Management / </span>
                        <Link to={"/learner_course_list"}><span className='icon2'>Learning Module List / </span></Link>
                        <span className='icon2'>Learning Module Details - </span>
                        <span className='icon2'>{!loading ? details && details.course_title + " -" : "loading.."} </span>
                        <span className='icon2'>{!loading ? details && details.course_code + " -" : "loading.."} </span>

                        {
                            state && state.learner_course_status == 'pass' ? <span className='badge text-bg-success text-capitalize'>{state && state.learner_course_status}</span> :
                                state && state.learner_course_status == 'failed' || state && state.learner_course_status == 'expired' ? <span className='badge text-bg-danger text-capitalize'>{state && state.learner_course_status}</span> :
                                    state && state.learner_course_status == 'pending' ? <span className='badge text-bg-warning text-capitalize'>{state && state.learner_course_status}</span> :
                                        state && state.learner_course_status == 'started' ? <span className='badge text-bg-info text-capitalize'>{state && state.learner_course_status}</span>
                                            : ''
                        }

                    </div>

                    <div className='d-lg-flex mt-2 mt-lg-0'>

                        {loading ? '' :
                            state && state.learner_course_status == 'pass' || state && state.learner_course_status == 'expired' ?
                                '' :
                                <h4>{formatTime(time)}</h4>
                        }
                    </div>
                </div>


                {loading ?

                    <div className='text-center mb-3'>
                        <PropagateLoader
                            color="#2262C6"
                            size={20}
                        />
                    </div>

                    :
                    details ?
                        <Tab.Container id="left-tabs-example" defaultActiveKey={details && !details.quiz_attempt_status ? 'result' : state && state.learner_course_status == 'pass' ? 'result' : details && details.lms_course_files && details.lms_course_files[0] && details.lms_course_files[0].id}>
                            <Row>
                                <Col sm={3}>
                                    <Nav variant="pills" className="flex-column" style={{ height: '70vh' }}>
                                        <PerfectScrollbar>
                                            {details && details.lms_course_files && details.lms_course_files.map((value, index) =>
                                                <Nav.Item key={index}>
                                                    <Nav.Link eventKey={value.id}>
                                                        <h5 style={{ marginBottom: '0' }}>
                                                            {value.content_title}
                                                        </h5>
                                                        {/* <span className='badge bg-info'>Pending</span> */}
                                                    </Nav.Link>
                                                </Nav.Item>
                                            )}
                                            {state && state.learner_course_status == 'pass' || state && state.learner_course_status == 'expired' ? '' :
                                                <Nav.Item>
                                                    <Nav.Link eventKey="quiz">
                                                        <h5 style={{ marginBottom: '0' }}>Start Quiz</h5>
                                                        {/* <span className='badge bg-warning'>Pending</span> */}
                                                    </Nav.Link>
                                                </Nav.Item>
                                            }
                                            <Nav.Item>
                                                <Nav.Link eventKey="add_note">
                                                    <h5 style={{ marginBottom: '0' }}>Add a Note</h5>
                                                    {/* <span className='badge bg-warning'>Pending</span> */}
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="notes_list">
                                                    <h5 style={{ marginBottom: '0' }}>Notes list</h5>
                                                    {/* <span className='badge bg-danger'>Success</span> */}
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item>
                                                <Nav.Link eventKey="ask_question">
                                                    <h5 style={{ marginBottom: '0' }}>Ask Question</h5>
                                                    {/* <span className='badge bg-danger'>Success</span> */}
                                                </Nav.Link>
                                            </Nav.Item>
                                            {state && state.learner_course_status == 'pass' || state && state.learner_course_status == 'failed' ?
                                                <Nav.Item>
                                                    <Nav.Link eventKey="result">
                                                        <h5 style={{ marginBottom: '0' }}>Result</h5>
                                                        {/* <span className='badge bg-danger'>Success</span> */}
                                                    </Nav.Link>
                                                </Nav.Item>
                                                : ''
                                            }
                                            {state && state.feedback_status == 'completed' ?
                                                <Nav.Item>
                                                    <Nav.Link eventKey="feedback">
                                                        <h5 style={{ marginBottom: '0' }}>Feedback</h5>
                                                        {/* <span className='badge bg-danger'>Success</span> */}
                                                    </Nav.Link>
                                                </Nav.Item>
                                                : ''
                                            }
                                        </PerfectScrollbar>
                                    </Nav>
                                </Col>

                                <Col sm={9}>

                                    <Tab.Content>

                                        {details && details.lms_course_files && details.lms_course_files.map((value, index) =>
                                            <Tab.Pane eventKey={value.id} key={index}>
                                                <div className='wrapper-admin'>
                                                    <div className='text-center' style={{ height: '70vh' }}>

                                                        {(value.file_type == 'jpg') || (value.file_type == 'png') ?
                                                            <img src={process.env.REACT_APP_IMAGE_URL + (value.file_path || value.upload_file)} className='img-fluid' style={{ maxHeight: '100%' }} />
                                                            : ''}

                                                        {value.source == 'link' || value.source == 'vimeo' || value.file_type == 'mp4' ?
                                                            <iframe className='section2-video' id="videoFrame" src={value.link ? value.link : value.upload_file ? process.env.REACT_APP_IMAGE_URL + value.upload_file : value.file_path ? process.env.REACT_APP_IMAGE_URL + value.file_path : ''} title="YouTube video" allowFullScreen style={{ height: '100%', width: '100%' }}></iframe>
                                                            : ''}

                                                        {value.source == 'youtube' ?
                                                            <iframe className='section2-video' id="videoFrame" src={`https://www.youtube.com/embed/${value.link}`} title="YouTube video" allowFullScreen style={{ height: '100%', width: '100%' }}></iframe>
                                                            : ''}

                                                        {value.file_type == 'pptx' ?
                                                            <iframe className='section2-video' id="videoFrame" src={value.file_path ? 'https://view.officeapps.live.com/op/embed.aspx?src=' + process.env.REACT_APP_IMAGE_URL + value.file_path : 'https://view.officeapps.live.com/op/embed.aspx?src=' + process.env.REACT_APP_IMAGE_URL + value.upload_file} title="YouTube video" allowFullScreen style={{ height: '100%', width: '100%' }}></iframe>
                                                            : ''}

                                                        {value.file_type == 'doc' || value.file_type == 'docx' ?
                                                            <iframe className='section2-video' id="videoFrame" src={'https://view.officeapps.live.com/op/embed.aspx?src=' + process.env.REACT_APP_IMAGE_URL + value.upload_file || 'https://view.officeapps.live.com/op/embed.aspx?src=' + process.env.REACT_APP_IMAGE_URL + value.file_path} title="Document" allowFullScreen style={{ height: '100%', width: '100%' }}></iframe>
                                                            : ''}

                                                        {/* {value.file_type == 'doc' ?
                                                            <iframe className='section2-video' id="videoFrame" src={'https://view.officeapps.live.com/op/embed.aspx?src=' + process.env.REACT_APP_IMAGE_URL + value.upload_file} title="YouTube video" allowFullScreen style={{ height: '100%', width: '100%' }}></iframe>
                                                            : ''}

                                                        {value.file_type == 'docx' ?
                                                            <iframe className='section2-video' id="videoFrame" src={'https://view.officeapps.live.com/op/embed.aspx?src=' + process.env.REACT_APP_IMAGE_URL + value.file_path} title="YouTube video" allowFullScreen style={{ height: '100%', width: '100%' }}></iframe>

                                                            : ''} */}

                                                        {value.file_type == 'pdf' ?
                                                            <div style={{ height: '70vh' }}>
                                                                <PerfectScrollbar>
                                                                    <div className='d-flex justify-content-center' style={{ borderBottom: "2px solid rgba(0, 0, 0, 0.1)" }}>
                                                                        <Toolbar>
                                                                            {props => {
                                                                                const {
                                                                                    CurrentPageInput,
                                                                                    EnterFullScreen,
                                                                                    GoToNextPage,
                                                                                    GoToPreviousPage,
                                                                                    NumberOfPages,
                                                                                    Print,
                                                                                    Zoom,
                                                                                    ZoomIn,
                                                                                    ZoomOut
                                                                                } = props
                                                                                return (
                                                                                    <>
                                                                                        <ZoomOut />
                                                                                        <Zoom />
                                                                                        <ZoomIn />
                                                                                    </>
                                                                                )
                                                                            }}
                                                                        </Toolbar>
                                                                    </div>
                                                                    <div
                                                                        style={{
                                                                            flex: 1,
                                                                            overflow: "hidden"
                                                                        }}
                                                                    >
                                                                        <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.10.111/build/pdf.worker.min.js">
                                                                            <Viewer
                                                                                fileUrl={process.env.REACT_APP_IMAGE_URL + (value.file_path || value.upload_file)}
                                                                                // renderPage={renderPage}
                                                                                plugins={[toolbarPluginInstance]}
                                                                            />
                                                                        </Worker>
                                                                    </div>
                                                                </PerfectScrollbar>
                                                            </div>
                                                            : ''}

                                                    </div>
                                                </div>
                                            </Tab.Pane>
                                        )}

                                        <Tab.Pane eventKey="quiz">
                                            <div className='wrapper-admin'>
                                                <div style={{ height: '70vh' }}>
                                                    <PerfectScrollbar>

                                                        <div className='card mb-2'>
                                                            <div className='card-header'>
                                                                <span style={{ fontWeight: '500', fontSize: '16px' }}>Read Instructions Properly Before Quiz Start </span>
                                                            </div>
                                                            <div className='card-body'>
                                                                <ul>
                                                                    <li>How to start the Quiz?</li>
                                                                    <li>What is the important points ?</li>
                                                                    <li>What about negative marking ?</li>
                                                                    <li>What if did not submit ?</li>
                                                                    <li>Full time of the quiz?</li>
                                                                    <li>How to start the Quiz?</li>
                                                                    <li>What is the important points ?</li>
                                                                    <li>What about negative marking ?</li>
                                                                    <li>What if did not submit ?</li>
                                                                    <li>Full time of the quiz?</li>
                                                                </ul>

                                                            </div>
                                                            <div className='card-footer'>
                                                                <div className='text-end'>
                                                                    <button className='btn btn_submit' type='button' disabled={details && (parseInt(details.min_view_time) * 60) > time ? true : false} onClick={() => start_quiz()}>Start Quiz</button>
                                                                </div>
                                                            </div>

                                                        </div>

                                                    </PerfectScrollbar>
                                                </div>
                                            </div>
                                        </Tab.Pane>

                                        <Tab.Pane eventKey="add_note">
                                            <div className='wrapper-admin'>
                                                <div style={{ height: '70vh' }}>
                                                    <Formik
                                                        initialValues={{
                                                            course_id: details && details.id,
                                                            notes: '',
                                                        }}
                                                        validationSchema={AddNotesSchema}
                                                        enableReinitialize
                                                        onSubmit={(values, action) => {
                                                            // console.log(values);
                                                            dispatch(addNoteTodo(values)).then(() => add_note_res(action))
                                                        }}
                                                    >
                                                        {({ values, errors, touched, handleChange, handleBlur }) => (
                                                            <Form>

                                                                <div className="mb-3">
                                                                    <label htmlFor="exampleFormControlTextarea1" className="form-label form_label">Note</label>
                                                                    <textarea className="form-control form_input" id="exampleFormControlTextarea1" placeholder='Write a Note here...' rows="10"
                                                                        name='notes' value={values.notes} onChange={handleChange} onBlur={handleBlur}
                                                                    />
                                                                    {errors.notes && touched.notes ? <span className='text-danger form_label'>{errors.notes}</span> : null}
                                                                </div>

                                                                <div className="text-end mt-3">
                                                                    <button type="submit" className="btn btn_submit">Submit</button>
                                                                </div>

                                                            </Form>
                                                        )}
                                                    </Formik>
                                                </div>
                                            </div>
                                        </Tab.Pane>

                                        <Tab.Pane eventKey="notes_list">
                                            <div className='wrapper-admin'>
                                                {notes && notes.length ?
                                                    <div style={{ height: '70vh' }}>
                                                        <DataTables
                                                            rowData={notes}
                                                            columnDefs={columnDefs}
                                                            height={'60vh'}
                                                        />
                                                    </div>
                                                    :
                                                    <div className='text-center'>
                                                        <h5>Notes list not found!!..</h5>
                                                    </div>
                                                }
                                            </div>
                                        </Tab.Pane>

                                        <Tab.Pane eventKey="ask_question">
                                            <div className='wrapper-admin'>
                                                <div style={{ height: '70vh' }}>
                                                    <Formik
                                                        initialValues={{
                                                            fk_ask_id: '',
                                                            course_id: details && details.id,
                                                            title: '',
                                                            description: '',
                                                            answer: '',
                                                        }}
                                                        validationSchema={AddQuestionSchema}
                                                        enableReinitialize
                                                        onSubmit={(values, action) => {
                                                            // console.log(values)
                                                            dispatch(addUpdateLearnerQuestionTodo(values)).then(() => add_question_res(action))
                                                        }}
                                                    >
                                                        {({ values, errors, touched, handleChange, handleBlur }) => (
                                                            <Form>

                                                                <div className="mb-3">
                                                                    <label htmlFor="" className="form-label form_label">Title</label>
                                                                    <input type="text" className='form_input form-control' placeholder='Enter Title'
                                                                        name='title' value={values.title || ''} onChange={handleChange} onBlur={handleBlur}
                                                                    />
                                                                    {errors.title && touched.title ? (<span className='text-danger form_label'>{errors.title}</span>) : null}
                                                                </div>

                                                                <div className="mb-3">
                                                                    <label htmlFor="exampleFormControlTextarea1" className="form-label form_label">Description</label>
                                                                    <textarea className="form-control form_input" id="exampleFormControlTextarea1" placeholder='Write a Description here...' rows="10"
                                                                        name='description' value={values.description} onChange={handleChange} onBlur={handleBlur}
                                                                    />
                                                                    {errors.description && touched.description ? <span className='text-danger form_label'>{errors.description}</span> : null}
                                                                </div>

                                                                <div className="text-end mt-3">
                                                                    <button type="submit" className="btn btn_submit">Submit</button>
                                                                </div>

                                                            </Form>
                                                        )}
                                                    </Formik>
                                                </div>
                                            </div>
                                        </Tab.Pane>

                                        <Tab.Pane eventKey="result">
                                            <div className='wrapper-admin'>
                                                {details && details.lms_learner_quizzes && details.lms_learner_quizzes.length ?
                                                    <div className='container-fluid'>
                                                        {/* <h5 className='text-center mb-4'>You have <span className={details && details.lms_learner_quizzes && details.lms_learner_quizzes[0] && details.lms_learner_quizzes[0].result_status == 'pass' ? 'text-success text-capitalize' : 'text-danger text-capitalize'}>{details && details.lms_learner_quizzes && details.lms_learner_quizzes[0] && details.lms_learner_quizzes[0].result_status}</span> the Examination</h5> */}
                                                        <h5 className='text-center mb-4'>You have <span className={`text-capitalize ${details?.lms_learner_quizzes?.[details.lms_learner_quizzes.length - 1]?.result_status === 'pass'
                                                            ? 'text-success'
                                                            : 'text-danger'
                                                            }`}>{details?.lms_learner_quizzes?.[details.lms_learner_quizzes.length - 1]?.result_status || 'N/A'}</span> the Examination</h5>
                                                        <div className='row row-flex'>

                                                            <div className='col-3'>
                                                                <div className='box match_height'>
                                                                    <div className="quiz-title">
                                                                        <h5>Total Questions</h5>
                                                                        {/* <p> {details && details.lms_learner_quizzes && details.lms_learner_quizzes[0] && details.lms_learner_quizzes[0].total_questions}</p> */}
                                                                        <p>{details?.lms_learner_quizzes?.[details.lms_learner_quizzes.length - 1]?.total_questions || 'N/A'}</p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-3">
                                                                <div className='box match_height'>
                                                                    <div className="quiz-title">
                                                                        <h5>Correct Answers</h5>
                                                                        {/* <p> {details && details.lms_learner_quizzes && details.lms_learner_quizzes[0] && details.lms_learner_quizzes[0].right_ans_count}</p> */}
                                                                        <p> {details?.lms_learner_quizzes?.[details.lms_learner_quizzes.length - 1]?.right_ans_count || 'N/A'}</p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-3">
                                                                <div className='box match_height'>
                                                                    <div className="quiz-title">
                                                                        <h5>Wrong Answers</h5>
                                                                        {/* <p> {details && details.lms_learner_quizzes && details.lms_learner_quizzes[0] && details.lms_learner_quizzes[0].wrong_ans_count}</p> */}
                                                                        <p> {details?.lms_learner_quizzes?.[details.lms_learner_quizzes.length - 1]?.wrong_ans_count || 'N/A'}</p>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* {details && details.lms_learner_quizzes && details.lms_learner_quizzes[0] && details.lms_learner_quizzes[0].result_status == 'pass' ?
                                                                <div className='col-3'>
                                                                    <div className='box match_height'>
                                                                        <h5>Get Certificate</h5>
                                                                        {
                                                                            details?.lms_learner_quizzes?.[0]?.res_certificate == '' || details?.lms_learner_quizzes?.[0]?.res_certificate == null ?
                                                                                <button className="btn btn-primary" onClick={() => genratePdf()} >
                                                                                    {spinner ?
                                                                                        <Spinner
                                                                                            as="span"
                                                                                            animation="border"
                                                                                            size="sm"
                                                                                            role="status"
                                                                                            aria-hidden="true"
                                                                                            className=''
                                                                                        />
                                                                                        :
                                                                                        <FaDownload color="white" fontSize="12px" />}
                                                                                </button> :
                                                                                <a href={process.env.REACT_APP_IMAGE_URL + details?.lms_learner_quizzes?.[0]?.res_certificate} className="btn btn-primary" target='_blank'><FaDownload color="white" fontSize="12px" /></a>
                                                                        }
                                                                    </div>
                                                                </div>
                                                                : ''
                                                            } */}
                                                            {details?.lms_learner_quizzes?.length > 0 &&
                                                                details.lms_learner_quizzes[details.lms_learner_quizzes.length - 1]?.result_status === 'pass' && (
                                                                    <div className='col-3'>
                                                                        <div className='box match_height'>
                                                                            <h5>Get Certificate</h5>
                                                                            {(() => {
                                                                                const lastQuiz = details.lms_learner_quizzes[details.lms_learner_quizzes.length - 1];
                                                                                return !lastQuiz?.res_certificate ? (
                                                                                    <button className="btn btn-primary" onClick={() => genratePdf()} >
                                                                                        {spinner ? (
                                                                                            <Spinner
                                                                                                as="span"
                                                                                                animation="border"
                                                                                                size="sm"
                                                                                                role="status"
                                                                                                aria-hidden="true"
                                                                                            />
                                                                                        ) : (
                                                                                            <FaDownload color="white" fontSize="12px" />
                                                                                        )}
                                                                                    </button>
                                                                                ) : (
                                                                                    <a
                                                                                        href={process.env.REACT_APP_IMAGE_URL + lastQuiz.res_certificate}
                                                                                        className="btn btn-primary"
                                                                                        target="_blank"
                                                                                        rel="noreferrer"
                                                                                    >
                                                                                        <FaDownload color="white" fontSize="12px" />
                                                                                    </a>
                                                                                );
                                                                            })()}
                                                                        </div>
                                                                    </div>
                                                                )
                                                            }


                                                            <div className='col-md-6 m-auto'>

                                                                {/* <ResultMeter series={details && details.lms_learner_quizzes && details.lms_learner_quizzes[0] && details.lms_learner_quizzes[0].percentage} /> */}
                                                                <ResultMeter
                                                                    series={
                                                                        details?.lms_learner_quizzes?.length > 0
                                                                            ? details.lms_learner_quizzes[details.lms_learner_quizzes.length - 1]?.percentage
                                                                            : 0
                                                                    }
                                                                />

                                                            </div>
                                                            <div className="col-md-12">
                                                                {!questionLoading ?
                                                                    mergedArray && mergedArray.map((value, index) =>
                                                                        <div className='card mb-2' key={index}>
                                                                            <div className='card-header'>
                                                                                <span style={{ fontWeight: '500', fontSize: '16px' }}> Q:{index + 1}  {value && value.lms_question && value.lms_question.question}</span>
                                                                            </div>
                                                                            <div className='card-body' style={{ backgroundColor: 'aliceblue' }}>
                                                                                <div className="row">

                                                                                    {(value && value.lms_question && value.lms_question.option1) || (value && value.lms_question && value.lms_question.image_option1) ?
                                                                                        <div className="col-md-6">
                                                                                            A. <span className={value && value.ans_by_user && value.ans_by_user.submit_ans === 'A' ? 'user_by' : ''}> {value && value.lms_question && value.lms_question.option1}</span> {value && value.lms_question && value.lms_question.correct_ans === 'A' ? <IoIosCheckmarkCircle style={{ color: "green" }} size={20} className=' ms-1 mb-1' /> : ''}
                                                                                            {
                                                                                                value && value.lms_question && value.lms_question.image_option1 === null || value && value.lms_question && value.lms_question.image_option1 === '' ? '' :
                                                                                                    <div style={{ height: '20vh' }}>
                                                                                                        <img src={process.env.REACT_APP_IMAGE_URL + value.lms_question.image_option1} alt="img" className='img-fluid' style={{ maxHeight: '100%' }} />
                                                                                                    </div>}
                                                                                        </div> : ""}

                                                                                    {(value && value.lms_question && value.lms_question.option2) || (value && value.lms_question && value.lms_question.image_option2) ?
                                                                                        <div className="col-md-6">
                                                                                            B. <span className={value && value.ans_by_user && value.ans_by_user.submit_ans === 'B' ? 'user_by' : ''}>  {value && value.lms_question && value.lms_question.option2}</span>{value && value.lms_question && value.lms_question.correct_ans === 'B' ? <IoIosCheckmarkCircle style={{ color: "green" }} size={20} className=' ms-1 mb-1' /> : ''}
                                                                                            {value && value.lms_question && value.lms_question.image_option2 === null || value && value.lms_question && value.lms_question.image_option2 === '' ? '' :
                                                                                                <div style={{ height: '20vh' }}>
                                                                                                    <img src={process.env.REACT_APP_IMAGE_URL + value.lms_question.image_option2} alt="img" className='img-fluid' style={{ maxHeight: '100%' }} />
                                                                                                </div>}
                                                                                        </div> : ""}

                                                                                    {(value && value.lms_question && value.lms_question.option3) || (value && value.lms_question && value.lms_question.image_option3) ?
                                                                                        <div className="col-md-6">
                                                                                            C. <span className={value && value.ans_by_user && value.ans_by_user.submit_ans === 'C' ? 'user_by' : ''}> {value && value.lms_question && value.lms_question.option3}</span>{value && value.lms_question && value.lms_question.correct_ans === 'C' ? <IoIosCheckmarkCircle style={{ color: "green" }} size={20} className=' ms-1 mb-1' /> : ''}
                                                                                            {
                                                                                                value && value.lms_question && value.lms_question.image_option3 === null || value && value.lms_question && value.lms_question.image_option3 === '' ? '' :
                                                                                                    <div style={{ height: '20vh' }}>
                                                                                                        <img src={process.env.REACT_APP_IMAGE_URL + value.lms_question.image_option3} alt="img" className='img-fluid' style={{ maxHeight: '100%' }} />
                                                                                                    </div>}
                                                                                        </div> : ""}

                                                                                    {(value && value.lms_question && value.lms_question.option4) || (value && value.lms_question && value.lms_question.image_option4) ?
                                                                                        <div className="col-md-6">
                                                                                            D. <span className={value && value.ans_by_user && value.ans_by_user.submit_ans === 'D' ? 'user_by' : ''}> {value && value.lms_question && value.lms_question.option4}</span>{value && value.lms_question && value.lms_question.correct_ans === 'D' ? <IoIosCheckmarkCircle style={{ color: "green" }} size={20} className=' ms-1 mb-1' /> : ''}
                                                                                            {value && value.lms_question && value.lms_question.image_option4 === null || value && value.lms_question && value.lms_question.image_option4 === '' ? '' :
                                                                                                <div style={{ height: '20vh' }}>
                                                                                                    <img src={process.env.REACT_APP_IMAGE_URL + value.lms_question.image_option4} alt="img" className='img-fluid' style={{ maxHeight: '100%' }} />
                                                                                                </div>}
                                                                                        </div> : ""}

                                                                                    {(value && value.lms_question && value.lms_question.option5) || (value && value.lms_question && value.lms_question.image_option5) ?
                                                                                        <div className="col-md-6">
                                                                                            E. <span className={value && value.ans_by_user && value.ans_by_user.submit_ans === 'E' ? 'user_by' : ''}> {value && value.lms_question && value.lms_question.option5}</span>{value && value.lms_question && value.lms_question.correct_ans === 'E' ? <IoIosCheckmarkCircle style={{ color: "green" }} size={20} className=' ms-1 mb-1' /> : ''}
                                                                                            {value && value.lms_question && value.lms_question.image_option5 === null || value && value.lms_question && value.lms_question.image_option5 === '' ? '' :
                                                                                                <div style={{ height: '20vh' }}>
                                                                                                    <img src={process.env.REACT_APP_IMAGE_URL + value.lms_question.image_option5} alt="img" className='img-fluid' style={{ maxHeight: '100%' }} />
                                                                                                </div>}
                                                                                        </div> : ""}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    ) : ''}
                                                            </div>

                                                        </div>
                                                    </div>
                                                    :
                                                    <div className="text-center">
                                                        <h5>Result not found!!..</h5>
                                                    </div>
                                                }
                                            </div>
                                        </Tab.Pane>

                                        <Tab.Pane eventKey="feedback">
                                            <div className='wrapper-admin' style={{ height: '75vh' }}>
                                                <PerfectScrollbar>
                                                    {details && details.lms_learner_feedbacks && details.lms_learner_feedbacks.filter(value => value.question_type == 'rating').map((val, index) =>
                                                        <div key={index} className='mb-2'>
                                                            {val.question} <br />
                                                            <Rating
                                                                readonly={true}
                                                                initialValue={val.rating}
                                                                fillColorArray={[
                                                                    "#f14f45",
                                                                    "#f16c45",
                                                                    "#f18845",
                                                                    "#f1b345",
                                                                    "#f1d045"
                                                                ]}
                                                            />
                                                        </div>
                                                    )}

                                                    {details && details.lms_learner_feedbacks && details.lms_learner_feedbacks.filter(value => value.question_type == 'text').map((val, index) =>
                                                        <div key={index} className='mb-2'>
                                                            <span>{val.question}</span> <br />
                                                            <span style={{ color: '#7d7d7d' }}>{val.submit_answer}</span>
                                                        </div>
                                                    )}
                                                </PerfectScrollbar>
                                            </div>
                                        </Tab.Pane>

                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container >
                        :
                        <div className='wrapper-admin'>
                            <div className='text-center'>
                                <h5>Learning Module Details not found</h5>
                            </div>
                        </div>
                }
            </div >

            <ToastContainer />

        </>
    )
}
